/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-18 15:16:59
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-19 11:22:54
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Collapse/AntdCollapse.tsx
 */
import React from 'react';

import css from './antdCollapse.less';

import { Collapse } from 'antd';

const { Panel } = Collapse;

const AntdCollapse = (props) => {
  const {
    open = [],
    setOpen,
    generalPanelClassName,
    data = [],
    headerProps = {},
  } = props;

  return (
    <Collapse
      activeKey={open}
      onChange={setOpen}
      ghost
      className={css.collapseContainer}>
      {data.map((i) => {
        const { header, content, key, customPanelClassName } = i;
        return (
          <Panel
            header={header}
            className={`${css.panelContainer} ${generalPanelClassName || ''} ${
              customPanelClassName || ''
            }`}
            key={key}
            showArrow={false}
            {...headerProps}>
            {content}
          </Panel>
        );
      })}
    </Collapse>
  );
};
const _Collapse = Collapse;
_Collapse.Panel = Panel;
export { _Collapse as OriCollapse };
export default AntdCollapse;
